<template>
  <!-- 暂无数据和加载中 -->
  <div class="noDataBox">
    <template v-if="!length && !loading&&showNoData">
      <!-- <i class="zanwushuju120 drmicon icon" /> -->
      <img :src="imgSrc" alt="" class="drmicon ">
      <p>{{ $t('tableData.noData') }}</p>
    </template>

    <template v-if="!length && loading">
      <i class="el-icon-loading" />
      <p>Loading...</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    length: {
      default: 0
    },
    loading: {
      default: true
    },
    showNoData: {// 因为表格无数据时，要求不显示暂无数据图片，而是显示表格表头加表格自带的暂无数据
      default: false
    }
  },
  data() {
    return {
      imgSrc: require('@/assets/icon/noData.png')
    }
  }
}
</script>

<style lang="scss" scoped>
//暂无数据
.noDataBox {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  width: 100%;
  background-color: transparent;
  border-radius: 10px;
  text-align: center;
  .icon {
    font-size: 100px;
  }
  .el-icon-loading {
    font-size: 70px;
    color: #999;
  }
  .drmicon{
    width:100px;
  }
}
</style>
